import { useEffect, useState } from 'react';
import { useLanguage } from '../../../Hooks/useLanguage';
import { Column, Row, TableDefinition } from '../DataTable.types';
import { mapDataToColumns } from '../Helpers/data.helpers';

const useDataTable = (data: any, tableDef: TableDefinition) => {
  const { t } = useLanguage();

  const [rows, setRows] = useState([] as Row[]);
  const [columns, setColumns] = useState([] as Column[]);
  const [_data, setData] = useState([] as any[]);

  // Initial Update from hook params for columns
  useEffect(() => {
    setColumns(tableDef.columns);
    const rowUpdate = mapDataToColumns(data, tableDef.columns);
    setRows(rowUpdate);
  }, [tableDef.columns]);

  // Initial Update from hook params for data
  useEffect(() => {
    setData(data);
    const rowUpdate = mapDataToColumns(data, tableDef.columns);
    setRows(rowUpdate);
  }, [data]);

  // Update rows when column configuration is changed on the fly
  useEffect(() => {
    const rowUpdate = mapDataToColumns(_data, columns);
    setRows(rowUpdate);
  }, [columns]);

  // Update rows when the data is being changed
  useEffect(() => {
    const rowUpdate = mapDataToColumns(_data, columns);
    setRows(rowUpdate);
  }, [_data]);

  return {
    originalData: _data,
    rows,
    columns,
    t,
    setColumns,
    setData,
  };
};

export default useDataTable;
